import * as React from "react";
import { Link, LinkProps } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import { default as Tab, TabProps } from '@material-ui/core/Tab';

//import HomeIcon from '@material-ui/icons/Home';

const LinkTab: React.ComponentType<TabProps & LinkProps> = Tab as React.ComponentType<TabProps & LinkProps>;

export default function AppSuiteNavBar() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div >
      <AppBar position="static" >
        <Tabs value={value} onChange={handleChange} centered>
          <LinkTab label='Asset Maintain'  component={Link} to="/saas/asset-maintain/dashboard" />
          <LinkTab label='Asset Predict' component={Link} to="/saas/asset-predict/dashboard" />
          <LinkTab label='Asset Operate' component={Link} to="/saas/asset-operate/dashboard" />
          <LinkTab label='Asset Invest' component={Link} to="/saas/asset-invest/dashboard" />
        </Tabs>
      </AppBar>
    </div>
  )
};
